var headerMediaBreakpoint = "(min-width: 1250px)";
var AccountDropdownOptionsSettings;
(function(AccountDropdownOptionsSettings) {
    AccountDropdownOptionsSettings["Logout"] = "Logout";
    AccountDropdownOptionsSettings["MyAccount"] = "MyAccount";
    AccountDropdownOptionsSettings["Settings"] = "Settings";
})(AccountDropdownOptionsSettings || (AccountDropdownOptionsSettings = {}));

export { AccountDropdownOptionsSettings, headerMediaBreakpoint };
